import React from 'react';
import Divider from 'src/components/10-atoms/Divider';
import GenericServerError from 'src/components/10-atoms/GenericServerError';
import Column from 'src/components/10-atoms/layout/Column';
import CustomScrollView from 'src/components/10-atoms/list-views/CustomScrollView';
import QueryHandler from 'src/components/10-atoms/QueryHandler';
import PageMeta from 'src/components/10-atoms/seo/PageMeta';
import EmptyList from 'src/components/templates/EmptyList.template';
import Page from 'src/components/templates/page/Page.template';
import PageBody from 'src/components/templates/page/PageBody.template';
import PageHeader from 'src/components/templates/page/PageHeader.template';
import PageNavbar from 'src/components/templates/page/PageNavbar.template';
import AppAssets from 'src/constants/appAssets';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import useI18n from 'src/modules/translations/hooks/useI18n';
import styleUtils from 'src/utils/styles';
import ReputationBadgeLoader from '../../components/reputation-badge/Loader';
import ReputationBadge from '../../components/reputation-badge/View';
import ReputationSummary from '../../components/reputation/Summary';
import useData from './useData';
const Reputation = ({ navigation }) => {
    const [{ styles }] = useTheme(stylesGenerator);
    const { translate } = useI18n();
    const [state, actions] = useData();
    return (React.createElement(Page, null,
        React.createElement(PageMeta, { title: "My Reputation", noIndex: true }),
        React.createElement(PageHeader, null,
            React.createElement(PageNavbar, { title: translate('Reputation'), backType: "back", onBackPress: navigation.goBack })),
        React.createElement(PageBody, null,
            React.createElement(CustomScrollView, { style: styleUtils.containerHeight },
                React.createElement(QueryHandler, { LoaderComponent: React.createElement(ReputationBadgeLoader, null), ErrorComponent: () => (React.createElement(GenericServerError, { error: state.reputationQuery.error, onRetry: actions.reputationQuery.fetch })), DataComponent: () => {
                        const isEmpty = state.reputationQuery.data.user_getDetails.reputation.badgesInfo
                            .badges.length === 0;
                        return (React.createElement(Column, null,
                            React.createElement(ReputationSummary, { variant: "details", style: styles.summary, reputation: state.reputationQuery.data.user_getDetails.reputation }),
                            isEmpty ? (React.createElement(EmptyList, { imgSrc: AppAssets.reputationEmptyBadges, message: translate("You'll find all your Badges in here.\nStart Contributing Now!") })) : (React.createElement(Column, { ItemSeparator: React.createElement(Divider, null) }, state.reputationQuery.data.user_getDetails.reputation.badgesInfo.badges.map(badge => (React.createElement(ReputationBadge, { key: badge.id, badge: badge })))))));
                    }, queryState: state.reputationQuery })))));
};
const stylesGenerator = createThemedStyle(({ theme }) => ({
    summary: {
        backgroundColor: theme.palette.background.dark,
        paddingHorizontal: theme.spacing.page,
        paddingVertical: theme.spacing.itemVerticalPadding,
    },
}));
export default Reputation;
